/**
 * TEMPORARY, the client half of the `PolicyFeatures` module in Ruby.
 *
 * Whether the playbook family — the playbook, the checklist, the pre-send checks
 * and the playbook-backed review of a counterparty's markup — is switched on for
 * this deployment. The layouts set the global from `CURRENT_DEPLOY_BRANCH`.
 *
 * Delete this and its callers when the family reaches production;
 * `plans/policy-features-flag/REVERT.md` lists every one.
 */
export function policyFeaturesEnabled() {
  // Only an explicit false is off. An absent global is a Jest harness or a page
  // that predates the flag, and the family is on in both — which is the same
  // default the branch check itself takes for a blank branch.
  return window._policy_features_enabled !== false;
}
